const swotGlobalTemplate = `
<!DOCTYPE html>
<html>
  <head>
    <style>
      #table-comment th { font-size: 12px; }
    </style>
  </head>
  <body>
    <table id="table-comment"> 
    <h2 class="pdf-table-heading">SWOT Analysis</h2>
    <tr>
    <th><h2>Asset:</h2></th>
    </tr>
      <tr>
        <th>Strengths</th>
      </tr>
      <tr>
        <td>
        {{{assetStrengthComment}}}
        </td>
      </tr>
      <tr>
        <th>Weakness</th>
      </tr>
      <tr>
        <td>
        {{{assetWeaknessComment}}}
        </td>
      </tr>
      <tr>
        <th>Opportunities</th>
      </tr>
      <tr>
        <td>
        {{{assetOpportunitiesComment}}}
        </td>
      </tr>
      <tr>
      <th>Threats</th>
    </tr>
    <tr>
      <td>
      {{{assetThreatsComment}}}
      </td>
    </tr>
    <tr>
    <th><h2>Sustainability:</h2></th>
    </tr>
      <tr>
        <th>Strengths</th>
      </tr>
      <tr>
        <td>
        {{{sustainabilityStrengthComment}}}
        </td>
      </tr>
      <tr>
        <th>Weakness</th>
      </tr>
      <tr>
        <td>
        {{{sustainabilityWeaknessComment}}}
        </td>
      </tr>
      <tr>
        <th>Opportunities</th>
      </tr>
      <tr>
        <td>
        {{{sustainabilityOpportunitiesComment}}}
        </td>
      </tr>
      <tr>
      <th>Threats</th>
    </tr>
    <tr>
      <td>
      {{{sustainabilityThreatsComment}}}
      </td>
    </tr>
    <tr>
    <th><h2>Leasing:</h2></th>
    </tr>
      <tr>
        <th>Strengths</th>
      </tr>
      <tr>
        <td>
        {{{leasingStrengthComment}}}
        </td>
      </tr>
      <tr>
        <th>Weakness</th>
      </tr>
      <tr>
        <td>
        {{{leasingWeaknessComment}}}
        </td>
      </tr>
      <tr>
        <th>Opportunities</th>
      </tr>
      <tr>
        <td>
        {{{leasingOpportunitiesComment}}}
        </td>
      </tr>
      <tr>
      <th>Threats</th>
    </tr>
    <tr>
      <td>
      {{{leasingThreatsComment}}}
      </td>
    </tr>
    <tr>
    <th><h2>Market:</h2></th>
    </tr>
      <tr>
        <th>Strengths</th>
      </tr>
      <tr>
        <td>
        {{{marketStrengthComment}}}
        </td>
      </tr>
      <tr>
        <th>Weakness</th>
      </tr>
      <tr>
        <td>
        {{{marketWeaknessComment}}}
        </td>
      </tr>
      <tr>
        <th>Opportunities</th>
      </tr>
      <tr>
        <td>
        {{{marketOpportunitiesComment}}}
        </td>
      </tr>
      <tr>
      <th>Threats</th>
    </tr>
    <tr>
      <td>
      {{{marketThreatsComment}}}
      </td>
    </tr>
    </table>
  </body>  
</html>
       `;

  export default swotGlobalTemplate;
